console.log('Alingsas Hero'); 